import { PublishTarget } from '../enums';
import { getPublishableServiceForPublishTarget } from '../helper';
import { PublishableService } from '../types';

/*
 * The publish targets whose scheduling is handled by the asynchronous "scheduled
 * email" step-function workflow (fetch CRM recipients -> upload list -> send).
 * This is the single source of truth for these platforms; to onboard a new CRM
 * email platform, add its `PublishTarget` here and every consumer stays in sync.
 */
export const SCHEDULED_WORKFLOW_PUBLISH_TARGETS = [
    PublishTarget.clubready,
    PublishTarget.glofox,
    PublishTarget.kite,
    PublishTarget.marianaTek,
    PublishTarget.mindbody,
    PublishTarget.zenoti,
] as const satisfies ReadonlyArray<PublishTarget>;

export type ScheduledWorkflowPublishTarget = (typeof SCHEDULED_WORKFLOW_PUBLISH_TARGETS)[number];

export type ScheduledWorkflowService = Extract<
    PublishableService,
    'clubReady' | 'glofox' | 'kite' | 'marianaTek' | 'mindbody' | 'zenoti'
>;

export const SCHEDULED_WORKFLOW_SERVICES: ReadonlyArray<PublishableService> = SCHEDULED_WORKFLOW_PUBLISH_TARGETS.map(
    getPublishableServiceForPublishTarget,
);

export function isScheduledWorkflowPublishTarget(target: PublishTarget): target is ScheduledWorkflowPublishTarget {
    return SCHEDULED_WORKFLOW_PUBLISH_TARGETS.some(scheduledWorkflowTarget => scheduledWorkflowTarget === target);
}

export function isScheduledWorkflowService(name: string): boolean {
    return SCHEDULED_WORKFLOW_SERVICES.some(service => service === name);
}
